// extracted by mini-css-extract-plugin
export default {"button":"mIBi5LKN2h9cuQvR7BWP"};